import { Row, Col, Card, Empty } from 'antd';
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import type { DistributionData } from '@/types';

interface Props {
  data: DistributionData | null;
  loading: boolean;
}

const PIE_COLORS = ['#1677ff', '#52c41a', '#722ed1', '#faad14', '#ff4d4f', '#13c2c2', '#eb2f96'];

const SERVICE_LABELS: Record<string, string> = {
  generate: '生成',
  optimize: '优化',
  one_click: '一键生成',
  analyze_intent: '意图分析',
  smart_complete: '智能补全',
};

export default function DistributionCharts({ data, loading }: Props) {
  if (loading) return <Row gutter={16}><Col span={12}><Card loading /></Col><Col span={12}><Card loading /></Col></Row>;
  if (!data) return <Empty />;

  const serviceData = data.promptServiceStats.map(s => ({
    ...s,
    label: SERVICE_LABELS[s.service_type] || s.service_type,
  }));

  return (
    <Row gutter={16}>
      <Col xs={24} lg={12}>
        <Card title="积分消耗分布" size="small">
          {data.creditUsage.length > 0 ? (
            <ResponsiveContainer width="100%" height={260}>
              <PieChart>
                <Pie
                  data={data.creditUsage}
                  cx="50%"
                  cy="50%"
                  innerRadius={50}
                  outerRadius={90}
                  dataKey="value"
                  nameKey="type"
                  label={({ type, percent }) => `${type} ${(percent * 100).toFixed(0)}%`}
                  fontSize={12}
                >
                  {data.creditUsage.map((_, idx) => (
                    <Cell key={idx} fill={PIE_COLORS[idx % PIE_COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip formatter={(v: number) => [`${v} 积分`, '消耗']} />
              </PieChart>
            </ResponsiveContainer>
          ) : (
            <Empty description="暂无数据" image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </Card>
      </Col>
      <Col xs={24} lg={12}>
        <Card title="提示词服务统计" size="small">
          {serviceData.length > 0 ? (
            <ResponsiveContainer width="100%" height={260}>
              <BarChart data={serviceData} layout="vertical">
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" fontSize={12} />
                <YAxis type="category" dataKey="label" fontSize={12} width={80} />
                <Tooltip />
                <Legend />
                <Bar dataKey="calls" fill="#1677ff" name="调用次数" radius={[0, 4, 4, 0]} />
                <Bar dataKey="credits" fill="#ff4d4f" name="消耗积分" radius={[0, 4, 4, 0]} />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <Empty description="暂无数据" image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </Card>
      </Col>
    </Row>
  );
}
